import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useContactReasons } from '~/hooks/useConversations';
import { useOrderDetailByIdNumber } from '~/hooks/useOrderDetails';

export function useCreateConversationWizard(baseOrderIdNumber = '') {
  const activeMerchantId = useSelector((state) => state.session.active_merchant.id);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showConfirmQuitModal, setShowConfirmQuitModal] = useState(false);
  const [orderNumber, setOrderNumber] = useState(baseOrderIdNumber);
  const [contactReason, setContactReason] = useState(null);

  const { isLoading, isError, data: order } = useOrderDetailByIdNumber(orderNumber, activeMerchantId);
  const { isLoading: isLoadingReasons, data: contactReasons } = useContactReasons(activeMerchantId);

  const openModal = () => setIsModalOpen(true);

  const confirmQuit = () => {
    setOrderNumber('');
    setContactReason(null);
    setShowConfirmQuitModal(false);
    setIsModalOpen(false);
  };

  const closeModal = () => {
    if (order) {
      setShowConfirmQuitModal(true);
    } else {
      confirmQuit();
    }
  };

  const dismissConfirmQuit = () => setShowConfirmQuitModal(false);

  const showPartialOrderWarning = orderNumber.length > 4 && orderNumber.length < 14;

  return {
    isModalOpen,
    openModal,
    closeModal,
    showConfirmQuitModal,
    confirmQuit,
    dismissConfirmQuit,
    orderNumber,
    setOrderNumber,
    contactReason,
    setContactReason,
    order,
    isLoading,
    isError,
    contactReasons,
    isLoadingReasons,
    showPartialOrderWarning,
  };
}
